import { IEscrowFileCompleteData } from '../../../types/order/escrow/IEscrowFileCompleteData';
import { IAchPullDepositData } from '../../../types/order/escrow/IAchPullDepositData';
import { IEscrowWireDisbursementsData } from '../../../types/order/escrow/IEscrowWireDisbursementsData';
import { IManualCheckDisbursementData } from '../../../types/order/escrow/IManualCheckDisbursementData';
import { IInternalTransferData } from '../../../types/order/escrow/IInternalTransferData';
import { IAchPushDisbursementData } from '../../../types/order/escrow/IAchPushDisbursementData';
import { eMatchedQueryValue } from 'types/accounting/eMatchedQueryValue';
import { isNil } from 'lodash';

export const generateCreateEditTransactionsInitialValues = (
  data?: IEscrowFileCompleteData,
  feeDisbursementIds?: string[]
): IEscrowFileCompleteData | undefined =>
  data &&
  feeDisbursementIds && {
    id: data.id ?? '',
    // incomings
    createdAt: '',
    updatedAt: '',
    depositEscrowBankAccount: data.depositEscrowBankAccount,
    achPullDeposits:
      data.achPullDeposits?.filter(({ enqueuedForDisbursementAt }: IAchPullDepositData) =>
        isNil(enqueuedForDisbursementAt)
      ) ?? [],
    wireDeposits: data.wireDeposits?.filter((t) => t.matched === eMatchedQueryValue.UNMATCHED) ?? [],
    checkDeposits: data.checkDeposits?.filter((t) => t.matched === eMatchedQueryValue.UNMATCHED) ?? [],
    // outgoings
    wireDisbursements:
      data.wireDisbursements
        ?.filter((item) => !feeDisbursementIds.includes(item.id))
        ?.filter(({ enqueuedForDisbursementAt }: IEscrowWireDisbursementsData) => isNil(enqueuedForDisbursementAt)) ??
      [],
    manualCheckDisbursements:
      data.manualCheckDisbursements
        ?.filter((item) => !feeDisbursementIds.includes(item.id))
        ?.filter(({ sentAtDate }: IManualCheckDisbursementData) => isNil(sentAtDate)) ?? [],
    restrictedInternalTransfers:
      data.restrictedInternalTransfers
        ?.filter((item) => !feeDisbursementIds.includes(item.id))
        ?.filter(({ enqueuedForDisbursementAt }: IInternalTransferData) => isNil(enqueuedForDisbursementAt)) ?? [],
    achPushDisbursements:
      data.achPushDisbursements
        ?.filter((item) => !feeDisbursementIds.includes(item.id))
        ?.filter(({ sentAt }: IAchPushDisbursementData) =>
          // sentAt === enqueuedForDisbursementAt
          isNil(sentAt)
        ) ?? [],
  };
